import { SWING as EASING } from '../utils/animate';
import { state } from './state';

// EASING: "swing", what velocity used (the configured `easeInOutBack` doesn't
// exist in velocity 1.x).

// Full-screen menu (#menu-wrapper, toggled by the [data-toggle="menu-wrapper"]
// buttons): slides open to the screen height, fades the tiles in, stops page
// scrolling and pauses the video in view (a looping one resumes on close).
export default function menu() {
    const wrapper = document.getElementById('menu-wrapper');
    if (!wrapper) return;
    const topMenu = document.getElementById('top-menu');

    const setWidth = () => { wrapper.style.width = `${document.documentElement.clientWidth}px`; };
    setWidth();
    window.addEventListener('resize', setWidth);

    // Small screens: the top menu's own list button.
    document.getElementById('top-menu-button')?.addEventListener('click', () => topMenu?.classList.toggle('open'));

    wrapper.addEventListener('toggler:change', ({detail: {open}}) => {
        const video = state.videoInView;
        if (open) {
            video?.pause();
            topMenu?.classList.remove('open');
        } else if (video?.classList.contains('video-loop')) {
            video.play().catch(() => {});
        }

        wrapper.style.transition = `height 400ms ${EASING}`;
        wrapper.style.height = open ? `${window.screen.availHeight}px` : '0px';
        document.querySelectorAll('.tiles-menu > .row').forEach((row) => {
            row.style.transition = `opacity 400ms ${EASING}`;
            row.style.opacity = open ? '1' : '0';
        });
        document.body.classList.toggle('noscroll', open);
    });
}
